import React from 'react';

var OverlayArrowIcon = function OverlayArrowIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "4",
    height: "6",
    viewBox: "0 0 4 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "img"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1L3 3L1 5",
    stroke: "#FEFEFE",
    "stroke-linecap": "round"
  }));
};
OverlayArrowIcon.displayName = "OverlayArrowIcon";

export { OverlayArrowIcon as default };
